import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";
import { FullPageMeetingRoom } from "@kaltura/mediaspace-shared-meeting-room";

export const render = getDsLayoutComponentRenderer(FullPageMeetingRoom);
